import * as React from "react";
import Modal from "@mui/material/Modal";

import classes from "./AshtrayModal.module.css";
import AuthContext from "../../../../Common/auth-context";
import AddAshtray from "./AddAshtray";

const AshtrayModal = (props) => {
  const { lable, handleClose } = props;
  const authCtx = React.useContext(AuthContext);
  // console.log(client_name);
  return (
    <div>
      <Modal
        open={authCtx.openAshtrayModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classes.maincontainer}>
          <div className={classes.mainheader}>
            <p className={classes.mainhead}>Ashtray</p>
            <p>{lable}</p>
          </div>
          <div className={classes.storecontainer}>
            <AddAshtray onClose={props.handleClose}/>
          </div>


        </div>
      </Modal>
    </div>
  );
};

export default AshtrayModal;
